export const __config = {
  wobble: {
    button: true,
  },
} as const;
